// ABJ demo clone of src/components/sitemanENT/siteman_ent_tgsp-1-4.js (TGSP 1.4, listed under Success stories 6.0).
// Copied verbatim 10/14/26 — copy and header colors pending from Jeff. Route: /abj-demo-ent-tgsp-1-4
import React from 'react';
import Container from 'react-bootstrap/Container';
import {Nav} from "react-bootstrap";
import '@fortawesome/fontawesome-svg-core/styles.css';
import {HashLink as Link} from "react-router-hash-link";

const SitemanENTTGSP1_4 = () => {

    return (
        <div>
            <div className="w-100">
                <Container>
                    <div className="w-100">
                        <div className="col-10 m-auto">
                            <div className="whiteBackground floatLeft clearLeft">
                                <section>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <h1 className="tileTitleHeader centeredPageHeader text-center entJourneyOrangeColor entJourneyOrangeBorderColor">Key
                                                Questions</h1>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <div className="col-6">
                                                <p className="boldLeadIn">TGSP content is coming on the TGSP version</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 backToTop">
                                        <div className="w-100">
                                            <p><a className="specialUseBackToTop entJourneyOrangeColor" href="#">BACK TO TOP <i className="fa fa-chevron-up"></i></a></p>
                                            <hr className="width100 entJourneyOrangeBorderColor" />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>

    )
};

export default SitemanENTTGSP1_4;
